module.exports = __webpack_public_path__ + "images/4-iadee8cb5e9f2301e0c16f47598428e75.svg";